export const MAX_HOURS_PER_WEEK = 168;

export const TIME_LIMIT_VALUES = [25, 50, 75, 100];

export const SPEND_LIMIT_VALUES = [500, 1000, 2000, 10000];

export const ALTERNATIVE_REWARD_THRESHOLD_VALUES = [0, 5000, 10000, 25000];

export const MAX_ALTERNATIVE_REWARD_THRESHOLD = 25000;

export const ALTERNATIVE_REWARD_THRESHOLD_ANCHOR =
  'jonum-alternative-reward-threshold';
